import { Button, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import React from "react";
import { ActionsMenuItem } from "./ActionsMenuItem";
import { Icon } from "@familyzone/component-library";
import { colours } from "utils/themeUtils";

export type ActionsDropdownItem = {
	icon: string;
	label: string;
	show: boolean;
	disabled: boolean;
	action: () => void;
	tooltip?: string;
	dataTestId?: string;
};

interface Props {
	title: string;
	dataTestId?: string;
	items: ActionsDropdownItem[];
}

export function ActionsMenu(props: Props): JSX.Element {
	return (
		<Menu>
			<MenuButton
				as={Button}
				columnGap={8}
				title={props.title}
				borderRadius={"4px"}
				padding={"10px 12px 10px 12px"}
				alignItems={"center"}
				height={"32px"}
				border={"1px solid #cdcdcd"}
				background={"white"}
				cursor={"pointer"}
				fontWeight={"medium"}
				color={colours.navy[800]}
				_hover={{
					background: "#F3F5F9",
				}}
				transition={"ease-in-out"}
				transitionDuration={"0.2s"}
				data-testid={props.dataTestId}
			>
				{props.title}
				<Icon icon={"fa-chevron-down"} variant="solid" color="#6B778C" boxSize={4} ml={8} />
			</MenuButton>
			<MenuList>
				{props.items.map(
					(item) =>
						item.show && (
							<ActionsMenuItem
								key={item.label}
								icon={item.icon}
								label={item.label}
								tooltip={item.tooltip}
								onClick={item.action}
								disabled={item.disabled}
								dataTestId={item.dataTestId}
							/>
						)
				)}
			</MenuList>
		</Menu>
	);
}
